import { request_maker } from "./networkDomain"

const axiosBaseQuery = () => {
  return async (arg, {}) => {
    let {
      url,
      method = "GET",
      body,
      params
    } = typeof arg === "string" ? { url: arg } : arg
    try {
      const response = await request_maker({
        url,
        method,
        data: body,
        params
      })
      return {
        data: {
          data: response?.data?.data,
          status: response?.data?.status,
          message: response?.data?.message,
          total: response?.data?.meta?.totalCount
        }
      }
    } catch (err) {
      const responseData = err?.response?.data
      const error =
        typeof responseData === "string"
          ? JSON.parse(responseData)
          : responseData
      return {
        error: {
          code: error?.error?.code,
          message:
            error?.error?.message ||
            "Something went wrong! Please try again later",
          detail:
            error?.error?.detail ||
            "Something went wrong! Please try again later",
          status: err?.response?.status || 500
        }
      }
    }
  }
}

export { axiosBaseQuery }
